class FakePointerRegister {
    constructor() {
        this.key_val_map = {}
    }

    register(key, fn) {
        this.key_val_map[key] = fn
    }

    unregister(key) {
        this.key_val_map[key] = undefined
    }

    get(key) {
        return (this.key_val_map[key]) ? this.key_val_map[key] : () => {}
    }

    dud = (e) => {
        e.preventDefault()
    }
}


const fakePointerRegister = new FakePointerRegister()

export default fakePointerRegister